import { faChevronDown, faChevronRight, faQuestionCircle, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { AccordionContext, Button, Card, useAccordionButton } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FormattedMessage, useIntl } from "react-intl";

const AccordionToggleButton = ({ label, tooltip, eventKey, callback, onReset }) => {
  const intl = useIntl();
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = currentEventKey === eventKey;
  const resetTitle = intl.formatMessage({ id: "app.common.Reset" });

  return (
    <Card.Header onClick={decoratedOnClick} role="button" className="flex-center">
      <FontAwesomeIcon icon={isCurrentEventKey ? faChevronDown : faChevronRight} className="me-2" />
      <FormattedMessage id={label} />
      {tooltip && (
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <FontAwesomeIcon icon={faQuestionCircle} className="ms-2" />
        </OverlayTrigger>
      )}
      {onReset && isCurrentEventKey && (
        <Button
          size="sm"
          className="ms-auto"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onReset(e);
          }}
          variant="link"
          title={resetTitle}
        >
          <FontAwesomeIcon icon={faUndo} />
        </Button>
      )}
    </Card.Header>
  );
};

export default AccordionToggleButton;
